<div class="delete-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.cancel-transport-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="flex-container-column">
        <div>
          <app-dictionary-key-select (selectionChanged)="optionsChanged($event)"
            label="{{'select cause' | translate: ['tmc.visit.overview.cancel-transport-dialog.causeTitle', translationService.language, translationService.revision]}}"
            [rootKey]="'tmc-yard.service.lookup.deletion-cause.options'" [required]="true" [selectedIndex]="selectedIndex">
          </app-dictionary-key-select>
        </div>
        <div class="flex-grow">
          <mat-form-field class="textarea-remark" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc.visit.overview.cancel-transport-dialog.remark"></sc-dictionary-label>
            </mat-label>
            <textarea appearance="fill"
              matInput [(ngModel)]="remark" [maxlength]="9999"
              [required]="cps.isPropertyTrue('visitoverview.delete.length.cause', false)" cdkTextareaAutosize
              cdkAutosizeMinRows="8" cdkAutosizeMaxRows="8"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div>
      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>



      <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-cancel-button class="cancel-button" (click)="cancelDialog()"
        [disabled]="isCancelDisabled()" dictionaryKey="shared.selection-dialog.action.cancel"></sc-cancel-button>
          <sc-content-spacer ></sc-content-spacer>
        <sc-button primary (click)="confirm()" class="confirm-button"
        [disabled]="isConfirmDisabled()" dictionaryKey="tmc.visit.overview.cancel-transport-dialog.button.confirm"></sc-button>
      </sc-actionbar>

    </div>
  </div>
</div>
